import { render, staticRenderFns } from "./publicExchange.vue?vue&type=template&id=5f78146f&scoped=true&"
import script from "./publicExchange.vue?vue&type=script&lang=js&"
export * from "./publicExchange.vue?vue&type=script&lang=js&"
import style0 from "./publicExchange.vue?vue&type=style&index=0&id=5f78146f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78146f",
  null
  
)

export default component.exports